
import DialogTemplate from '@/_components/dialog/template/template.vue'

export default {
    name: 'DeleteInputConfirmationDialog',
    components: { DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },
}
